import { Tabs } from 'antd';
import { useEditorStore, type LeftTab } from '../store/store';
import { MaterialsTab } from './MaterialsTab';
import { PagesTab } from './PagesTab';
import { LayersTab } from './LayersTab';
import { DesignTab } from './DesignTab';

export function Sidebar() {
  const leftTab = useEditorStore((s) => s.ui.leftTab);
  const setLeftTab = useEditorStore((s) => s.setLeftTab);
  return (
    <Tabs
      activeKey={leftTab}
      onChange={(k) => setLeftTab(k as LeftTab)}
      centered
      size="small"
      style={{ height: '100%' }}
      items={[
        { key: 'materials', label: '物料', children: <MaterialsTab /> },
        { key: 'pages', label: '页面', children: <PagesTab /> },
        { key: 'layers', label: '图层', children: <LayersTab /> },
        { key: 'design', label: '换风格', children: <DesignTab /> },
      ]}
    />
  );
}
